































import { Vue, Component } from "vue-property-decorator";
import Navbar from "../../components/Navbar.vue";
import FooterPage from "../../components/FooterPage.vue";
import AusterInput from "../../components/AusterInput.vue";
import AusterButton from "../../components/AusterButton.vue";
import userPublicModel from "@/models/user_public.model";

@Component({
  components: {
    Navbar,
    FooterPage,
    AusterInput,
    AusterButton,
  },
})
export default class DeleteUser extends Vue {
    userInfo: any = {
    email: "",
    fullname : "",
    comments : "",
    register : "",
  };

  async sendForm() {
    console.log("deletar", this.userInfo)
    //verificar os campos
    if (this.userInfo.email === "" || this.userInfo.fullname === "" || this.userInfo.comments === "" || this.userInfo.register === "") {
      this.$vs.notification({
        color: "danger",
        title: ``,
        text: "Todos os campos são obrigatórios.",
        type: "alert",
      });
      //return;
    } else if (this.userInfo.comments.toUpperCase() !== "CONCORDO COM A EXCLUSÃO DEFINITIVA")
       {
        this.$vs.notification({
          color: "danger",
          title: ``,
          text: "Por favor, digite a frase corretamente.",
          type: "alert",
        });
      } else {
        //enviar o form
        const loading = this.$vs.loading({ color: '#FABA01' });
        try {      
            await userPublicModel.sendFormDeleteUser(this.userInfo.email, this.userInfo.fullname, this.userInfo.register);
            this.$vs.notification({ text: "A solicitação de exclusão foi enviada e está sendo analisada.", color: "#2E7179" });
            this.userInfo = {
                email: "",
                fullname : "",
                comments : "",
                register : "",
            };
        } catch (error) {
            this.$vs.notification({ text: "Não foi possível enviar. Tente novamente.", color: "#FF6767" });
            console.error(error);
        }
        loading.close();
      }
    }
  
}
